import { makeStyles } from '@material-ui/styles';

export default makeStyles(
    {
        container: {
            marginTop: '90px',
            marginBottom: '30px',
        },



        filaContainer: {
            // marginButton: '2rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingLeft: '0px',
            paddingRight: '0px',
        },

        tituloPrincipal: {
            fontWeight: '500',
            fontSize: '26px',
            lineHeight: '43px',
            color: '#02599E',
        },

        titulo: {
            marginTop: '10px',
            fontWeight: '400',
            fontSize: '20px',
            lineHeight: '43px',
            color: '#02599E',
        },

        backdrop: {
            zIndex: 10,
            color: '#fff',
        },

        modal: {
            outline: 0,
        },
    },
    { index: 1 }
);
